import React from 'react';
import { Button, InputText, colors } from '@insurancemenu/imenu-components-lib';
import SubtitleWithLines from 'components/common/SubtitleWithLines';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import FormsSpinner from 'components/common/FormSpinner';
import ErrorMessage from 'components/common/ErrorMessage';
import ActionModal from 'components/common/ActionModal';
import { Mail } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useHistory } from 'react-router-dom';
import { createStyles } from './styles';

const ForgotPasswordForm = observer((): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  // Mobx store
  const {
    forgotPasswordStore: {
      forgotPasswordForm,
      loading,
      showResetPasswordError,
      showPasswordRecoveryModal,
      forgotPassword,
      setShowPasswordRecoveryModal,
    },
  } = useRootStore();

  const isFormValid = forgotPasswordForm.isFormValid() && forgotPasswordForm.fields.email.value;

  const onForgotPassword = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    void forgotPassword();
  };

  return (
    <form id="forgot-password-form" onSubmit={onForgotPassword} className={classes.form}>
      <SubtitleWithLines
        text="Please enter the email address your profile is setup under. We'll send you a link to reset your password if your account has been registered in the past."
        className={classes.subtitle}
      />
      <InputText
        className={classes.input}
        label="Email address"
        name="email"
        value={forgotPasswordForm.fields.email.value}
        onChange={forgotPasswordForm.onFieldChange}
        validationPassed={!forgotPasswordForm.fields.email.unpassedValidationMsg}
        validationMessage={forgotPasswordForm.fields.email.unpassedValidationMsg || ''}
      />
      <div className={showResetPasswordError ? classes.buttonWrapperWithError : classes.validButtonWrapper}>
        {showResetPasswordError && (
          <ErrorMessage error="We couldn't find your account. Try a different email or contact your administrator about setting up an account." />
        )}
        <Button
          htmlType="submit"
          type="contained"
          color="primary"
          size="large"
          className={classes.button}
          disabled={!isFormValid}
        >
          Email Reset Password Link
        </Button>
      </div>
      <ActionModal
        show={showPasswordRecoveryModal}
        title="Password reset email sent"
        subtitle="Please click the link within the email to reset your password."
        closeButtonText="Back to login"
        icon={<Mail width="5.6rem" color={colors.green[600]} />}
        className={classes.passwordRecoveryModal}
        onClose={(): void => {
          setShowPasswordRecoveryModal(false);
          history.push('/login');
        }}
      />
      <FormsSpinner display={loading} />
    </form>
  );
});

export default ForgotPasswordForm;
